import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import seoServices from '../Components/Services/Images/seo/seo.png';
import Bg2 from '../Components/Services/Images/seo/bg2.png';
import Pricing1 from '../Components/Pricing/Images/1.png';
import Pricing2 from '../Components/Pricing/Images/2.png';
import Pricing3 from '../Components/Pricing/Images/3.png';
import Icon1 from '../Components/Services/Images/seo/1.svg';
import Icon2 from '../Components/Services/Images/seo/2.svg';
import Icon3 from '../Components/Services/Images/seo/3.svg';
import Icon4 from '../Components/Services/Images/seo/4.svg';
import Icon5 from '../Components/Services/Images/seo/5.svg';
import Icon6 from '../Components/Services/Images/seo/6.svg';
import Seo1 from '../Components/Services/Images/seo/seo1.jpg';
import Seo2 from '../Components/Services/Images/seo/seo2.png';
import Seo3 from '../Components/Services/Images/seo/seo3.png';
import Check from '../Components/Services/Images/seo/check1.svg';
import Pencil from '../Components/Services/Images/seo/pencil.svg';
import Search from '../Components/Services/Images/seo/search.svg';
import Pricing from '../Components/Pricing/Pricing';
import Testimonial from '../Components/Testimonial/Testimonial';
import ClientsCarousel from '../Components/ClientsCarousel/ClientsCarousel';
import Newsletter from '../Components/Newsletter';

function SeoServices() {
    const packages = [
        {
            name: "New Startup",
            price: "Free",
            features: ["1000 Messages per month", "2 GB file storage", "20 Projects per month", "Premium support"],
            icon: Pricing1
        },
        {
            name: "Business Website",
            price: "$11",
            features: ["1000 Messages per month", "2 GB file storage", "20 Projects per month", "Premium support"],
            icon: Pricing2
        },
        {
            name: "E-Commerce Store",
            price: "$22",
            features: ["1000 Messages per month", "2 GB file storage", "20 Projects per month", "Premium support"],
            icon: Pricing3
        }
    ];

    const seoServicesBlocks = [
        {
            icon: Icon1,
            title: "Social Marketing",
            description: "Social Marketing is a type of marketing that utilizes social media platforms to promote a brand, product, or service. It involves the use of social media platforms such as Facebook, Twitter, Instagram, LinkedIn, YouTube, etc."
        },
        {
            icon: Icon2,
            title: "SEO Optimization",
            description: "SEO optimization is crucial for businesses and websites that want to increase their target audience. By optimizing their website for search engines, they can attract more organic traffic to their site, which can lead to increased brand awareness."
        },
        {
            icon: Icon3,
            title: "Content Marketing",
            description: "Content marketing involves various steps such as identifying the target audience, developing a content strategy, creating high-quality content, distributing and promoting the content on various channels, and measuring the effectiveness of the content."
        },
        {
            icon: Icon4,
            title: "Pay Per Click",
            description: "PPC advertising is a highly effective way to reach a specific target audience as the ads can be targeted based on various factors such as keywords, demographics, interests, and behaviors. This allows businesses to reach their ideal customer and drive more qualified traffic to their website."
        },
        {
            icon: Icon5,
            title: "Social Marketing",
            description: "By implementing a well-planned social marketing strategy, businesses can build a strong online presence and improve their brand reputation. They can also build a community of loyal followers who are more likely to engage with their brand and purchase their products or services."
        },
        {
            icon: Icon6,
            title: "Web Analytics",
            description: "Web analytics is the process of collecting, analyzing, and reporting data about website visitors and their behavior. It involves using tools and techniques to measure website traffic, user engagement, and conversion rates."
        }
    ];

    const sections = [
        {
            title: "Search Engine Optimization Generate 100% Traffic",
            description: "Our support team will get assistance from AI-powered suggestions, making it quicker than ever to handle support requests. Our support team will get assistance from AI-powered suggestions, making it quicker than ever to handle support requests.",
            image: Seo1,
            checkLists1: "Keyword Analysis & Research",
            checkLists2: "On-site Optimization",
            listIcon: Check
        },
        {
            title: "Digital marketing tools techniques, strategies & skills",
            description: "By implementing a well-planned digital marketing strategy and mastering the essential skills, businesses can reach their target audience, build brand awareness, generate leads, increase sales, and achieve business objectives.",
            image: Seo2,
            checkLists1: "Visitor Conversion Rate",
            checkLists2: "Content Optimization Services",
            listIcon: Pencil,
            listIcon2: Search,
        },
        {
            title: "Perfect solution for your business",
            description: "Our support team will get assistance from AI-powered suggestions, making it quicker than ever to handle support requests. Our support team will get assistance from AI-powered suggestions, making it quicker than ever to handle support requests.",
            image: Seo3,
            playVideoLink: "https://www.youtube.com/watch?v=c7XEhXZ_rsk"
        }
    ];

    return (
        <>
            <div className="header-area h8-banner-area h8-banner-area-bg mg-top-50">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6 offset-xl-1">
                            <div className="header-inner-details">
                                <div className="header-inner">
                                    <h5 className="wow animated fadeInUp" data-wow-duration="1s" data-wow-delay="0s">The Best Agency For Digital Marketing</h5>
                                    <h1 className="title wow animated fadeInUp" data-wow-duration="1s" data-wow-delay="0s">Promote Your Website With <span>SEO Service</span></h1>
                                    <p className=" wow animated fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">Good business leaders create articulate the vision,passionately vision,and relentlessly drive it to completionrt working with an company that can provide everything.</p>
                                    <div className="btn-wrapper desktop-left padding-top-20 wow animated fadeInUp" data-wow-duration="1s" data-wow-delay="0.6s">
                                        <a href="#" className="btn btn-radius btn-red-border mr-2 mb-2">Start Free trial</a>
                                        <a href="#" className="btn btn-radius btn-red mb-2">Get Premium</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-5 hidden-sm">
                            <div className="banner-animate-thumb banner-animate-thumb-2">
                                <div className="header-img-1 wow animated fadeInRight" data-wow-duration="1s" data-wow-delay="0s">
                                    <img src={Bg2} alt="banner-img" />
                                </div>
                                <div className="header-img-2 wow animated fadeInDown" data-wow-duration="1s" data-wow-delay="0.5s">
                                    <img src={seoServices} alt="banner-img" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="service-area sbtc-service-area pd-top-30">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-6 col-lg-9">
                            <div className="section-title text-center">
                                <h2 className="title pb-2">Our <span>SEO</span> Services</h2>
                                <p className="pb-3">Our users are impatient. They're probably distracted too. Keep it simple and beautiful, fun and functional. Clean aesthetics supported by a strong concept is what we stand for.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row custom-gutters-16 justify-content-center">
                        {seoServicesBlocks.map((service, index) => (
                            <div className="col-xl-4 col-lg-6 col-sm-6" key={index}>
                                <div className="single-service-2 style-two text-center">
                                    <div className="thumb">
                                        <img src={service.icon} alt="service" />
                                    </div>
                                    <h6>{service.title}</h6>
                                    <p>{service.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {sections.map((section, index) => (
                <div className={index % 2 === 0 ? "sbbs-business-manage-area mg-top-75" : "sbbs-data-analytics-area mg-top-45"} key={index}>
                    <div className="container">
                        <div className="row">
                            <div className={index % 2 === 0 ? "col-xl-5 col-lg-6 order-lg-12 desktop-center-item" : "col-xl-5 col-lg-6 desktop-center-item"}>
                                <div className={index % 2 === 0 ? "text-lg-left text-center" : "desktop-center-area"}>
                                    <div className="section-title style-two">
                                        <h2 className="title">{section.title}</h2>
                                        <p>{section.description}</p>
                                    </div>
                                    <div className="row">
                                        <div className="col-9">
                                            {index === 0 && (
                                                <div>
                                                    <div className="FusionHub-check-list">
                                                        <img src={section.listIcon} alt="check" />
                                                        <span>{section.checkLists1}</span>
                                                    </div>
                                                    <div className="FusionHub-check-list">
                                                        <img src={section.listIcon} alt="check" />
                                                        <span>{section.checkLists2}</span>
                                                    </div>
                                                </div>
                                            )}
                                            {index === 1 && (
                                                <div>
                                                    <div className="FusionHub-check-list">
                                                        <img src={section.listIcon} alt="check" />
                                                        <span>{section.checkLists1}</span>
                                                    </div>
                                                    <div className="FusionHub-check-list">
                                                        <img src={section.listIcon2} alt="check" />
                                                        <span>{section.checkLists2}</span>
                                                    </div>
                                                </div>
                                            )}
                                            {index === 2 && (
                                                <div className="hover single-video-play">
                                                    <span>Play Video</span>
                                                    <a href={section.playVideoLink} className="video-play-btn mfp-iframe"><FontAwesomeIcon icon={faPlay} className='text-white' /></a>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className={index % 2 === 0 ? "col-xl-7 col-lg-6 order-lg-1" : "col-xl-7 col-lg-6"}>
                                <img src={section.image} alt="video" />
                            </div>
                        </div>
                    </div>
                </div>
            ))}

            <Pricing packages={packages} hostingName={'Choose your pricing'} />
            
            {/* <Testimonial />
            <ClientsCarousel /> */}

            <Newsletter />
        </>

    )
}

export default SeoServices;
